// extracted by mini-css-extract-plugin
export default {"wrapper":"Switch_wrapper__b3wj8","labelRight":"Switch_labelRight__sjkjn","label":"Switch_label__t2Pk0","Root":"Switch_Root__+3uVD","Thumb":"Switch_Thumb__tQhg7"};